export const INTERCOM_APP_ID = "nkuom8a6";
export const MICROSOFT_360_LOGIN_ENABLED = false;
